import React from 'react'
import { navigateTo } from 'gatsby-link'
import styled, { injectGlobal } from 'styled-components'
import ScrollBackground from 'react-scrolling-color-background'

class ScrollProgress extends React.Component {

	state = {
		scrollProgress: 0
	}
		
	componentDidMount() {
		window.addEventListener('scroll', this.handleScroll);
	}
	
    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
	}
	
	handleScroll = () => {
		this.setState({
			scrollProgress: (window.pageYOffset / (document.body.scrollHeight - window.innerHeight)) * 100
		})
    }
	
	render() {
		const { scrollProgress } = this.state;

		return (
			<React.Fragment>
				<ProgressBar>
					<Bar
						style={{
							right: `${-(scrollProgress - 100)}%`
						}}
					/>
					<Track/>
				</ProgressBar>
			</React.Fragment>
		)
	}
}

const ProgressBar = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	height: 2px;
	z-index: 11;
	transform: translate3d(0,0,0);
	max-width: 100vw;
	overflow: hidden;
`

const Bar = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	height: 2px;
	z-index: 2;
	background: #4D402E;
	will-change: right;
	transform: translate3d(0,0,0);
`

const Track = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: #EDECEA;
	z-index: 1;
`

export default ScrollProgress



// WEBPACK FOOTER //
// ./src/components/ScrollProgress/ScrollProgress.js